import type { Place } from "./api";
import { ALLOW_TEXT, askText, placeMark } from "./place";

/** Rule D-19: the driver confirms an entry away from the stop, or cancels and nothing is saved. */
export function PlaceConfirm({
  id,
  place,
  farM,
  hint,
  disabled,
  onYes,
  onNo,
}: {
  id: string;
  place: Place;
  farM: number;
  hint: boolean;
  disabled?: boolean;
  onYes: () => void;
  onNo: () => void;
}) {
  return (
    <div
      className="confirm place-confirm"
      role="group"
      aria-label="Away from the stop"
      data-testid="place-confirm"
      data-check={place.check}
      onKeyDown={(e) => {
        if (e.key === "Escape") onNo();
      }}
    >
      <p>
        <span aria-hidden="true">⚠ </span>
        {askText(place, farM)}
      </p>
      {hint && place.check === "denied" && (
        <p className="sub" data-testid="place-allow-hint">
          {ALLOW_TEXT}
        </p>
      )}
      <p>
        <button id={`place-yes-${id}`} type="button" className="primary" data-testid="place-yes" disabled={disabled} onClick={onYes}>
          I am at this stop
        </button>{" "}
        <button type="button" data-testid="place-no" disabled={disabled} onClick={onNo}>
          Cancel
        </button>
      </p>
    </div>
  );
}

/** Rule D-19: a small marker on a visit that the driver confirmed away from the stop. */
export function PlaceMark({ place }: { place?: Place | null }) {
  const mark = placeMark(place);
  if (!mark) return null;
  return (
    <span className="sub place-mark" data-testid="visit-place-mark" title={mark}>
      {" "}
      <span aria-hidden="true">⚠ </span>
      {mark}
    </span>
  );
}
